// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"451e78c1","787":"57cd1f6f"}[chunkId] + ".chunk.js";
};